import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { API_URL } from '../pages/config/env';

function Register() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    id: "",
    nickname: "",
    password1: "",
    password2: "",
    hiddenid: "",
    hiddenpassword: "",
  });
  const [idMessage, setIdMessage] = useState("");
  const [pwMessage, setPwMessage] = useState("");
  const [pwCheckMessage, setPwCheckMessage] = useState("");

  // -------------------------------
  // ID 체크
  // -------------------------------
  const checkId = async (value) => {
    const idc = value.replace(/[^a-z0-9_-]/g, "");

    if (idc.length >= 4) {
      const number = idc.search(/[0-9]/g);
      const alphabet = idc.search(/[a-z]/g);
      if (number >= 0 && alphabet >= 0) {
        try {
          const res = await fetch(`${API_URL}/api/auth/idcheck`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: idc }),
          });
          const data = await res.json();
          if (data.exists) {
            setIdMessage("아이디가 존재합니다.");
            setForm((prev) => ({ ...prev, hiddenid: "" }));
          } else {
            setIdMessage("사용할 수 있는 아이디입니다.");
            setForm((prev) => ({ ...prev, hiddenid: "1" }));
          }
        } catch (err) {
          console.error(err);
          setIdMessage("아이디 확인 중 오류 발생");
        }
      } else {
        setIdMessage("영문 및 숫자 조합이 아닙니다.");
        setForm((prev) => ({ ...prev, hiddenid: "" }));
      }
    } else {
      setIdMessage("영문, 숫자(4자리 이상)");
      setForm((prev) => ({ ...prev, hiddenid: "" }));
    }
  };

  // -------------------------------
  // 비밀번호 체크
  // -------------------------------
  const checkPassword = (pw1, pw2) => {
    const pwc = pw1.replace(
      /[^a-zA-Z0-9\~\`\!\@\#\$\%\^\&\*\(\)\_\-\+\=\{\}\[\]\|\\\:\;\"\'\<\>\,\.\?\/]/g,
      ""
    );

    const number = pw1.search(/[0-9]/g);
    const alphabet = pw1.search(/[a-z]/ig);
    const special = pw1.search(/[\~\`\!\@\#\$\%\^\&\*\(\)\_\-\+\=\{\}\|\\\:\;\"\'\<\>\,\.\?\/]/g);

    if (alphabet >= 0 && number >= 0 && special >= 0 && pwc.length >= 4) {
      setPwMessage("");
      if (pw1 === pw2) {
        setPwCheckMessage("비밀번호가 확인되었습니다.");
        setForm((prev) => ({ ...prev, hiddenpassword: "1" }));
      } else {
        setPwCheckMessage("비밀번호와 동일한 값을 입력해주세요.");
        setForm((prev) => ({ ...prev, hiddenpassword: "" }));
      }
    } else {
      setPwMessage("영문, 숫자, 특수문자(4자리 이상)");
      setPwCheckMessage("비밀번호와 동일한 값을 입력해주세요.");
      setForm((prev) => ({ ...prev, hiddenpassword: "" }));
    }
  };

  // -------------------------------
  // 폼 제출
  // -------------------------------
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch(`${API_URL}/api/auth/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: form.id,
          nickname: form.nickname,
          password: form.password1,
          hiddenid: form.hiddenid,
          hiddenpassword: form.hiddenpassword,
        }),
      });
      const data = await res.json();

      if (data.success) {
        alert(data.message);
        navigate("/login");
      } else {
        alert(data.message);
      }
    } catch (err) {
      console.error(err);
      alert("회원가입 중 오류가 발생했습니다.");
    }
  };

  return (
    <>
    <div className="container py-4">
      <div className="container-fluid p-0">
        <main className="col-md-12 bg-light">
          <div className="col-md-6 offset-md-3 p-2">
          <form
            className="p-4 p-md-5 border-0 rounded-3 bg-light"
            onSubmit={handleSubmit}
          >
            <div className="form-floating text-center">
              <p className="fs-2">회원가입</p>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="id"
                  placeholder="아이디"
                  value={form.id}
                  onChange={(e) => {
                    const val = e.target.value;
                    setForm((prev) => ({ ...prev, id: val }));
                    checkId(val);
                  }}
                  required
                />
                <label>아이디</label>
                <div className="text-danger">{idMessage}</div>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="text"
                  className="form-control"
                  name="nickname"
                  placeholder="이름"
                  value={form.nickname}
                  onChange={(e) =>
                    setForm((prev) => ({ ...prev, nickname: e.target.value }))
                  }
                  required
                />
                <label>이름</label>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="password"
                  className="form-control"
                  name="password1"
                  placeholder="비밀번호"
                  value={form.password1}
                  onChange={(e) => {
                    const val = e.target.value;
                    setForm((prev) => ({ ...prev, password1: val }));
                    checkPassword(val, form.password2);
                  }}
                  required
                />
                <label>비밀번호</label>
                <div className="text-danger">{pwMessage}</div>
              </div>

              <div className="form-floating mb-3">
                <input
                  type="password"
                  className="form-control"
                  name="password2"
                  placeholder="비밀번호 확인"
                  value={form.password2}
                  onChange={(e) => {
                    const val = e.target.value;
                    setForm((prev) => ({ ...prev, password2: val }));
                    checkPassword(form.password1, val);
                  }}
                  required
                />
                <label>비밀번호(확인)</label>
                <div className="text-danger">{pwCheckMessage}</div>
              </div>

              <div className="w-100 btn-group">
                <button className="btn btn-primary" type="submit">
                  가입
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => navigate("/login")}
                >
                  취소
                </button>
              </div>
            </div>
          </form>
        </div>
        </main>
      </div>
    </div>
    </>
  );
}

export default Register;